export default __webpack_public_path__ + "static/media/a5.655ae598.png";